import * as React from 'react'
export function Champ({ title = 'Champ', className, variation, ...props }) {
  return (
    <svg
      viewBox="0 0 62 60"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
      className={className}
      data-variation={variation}
      {...props}
    >
      <title>{title}</title>
      <g clip-path="url(#clip0_9893_3065)">
        <path
          d="M58.9038 3.48097H49.7531C49.7531 2.02397 48.5626 0.833496 47.1056 0.833496H14.412C12.955 0.833496 11.7645 2.02397 11.7645 3.48097H2.61381C1.37002 3.48097 0.375 4.476 0.375 5.71978V17.5179C0.375 22.5286 2.75595 27.2372 6.78936 30.2045L11.8178 33.9181C12.1021 36.7965 13.95 39.3019 16.6685 40.3857L22.8519 42.8378C25.8192 44.0105 27.756 46.8889 27.756 50.0695V50.336C27.756 51.9707 26.6188 53.3744 25.0196 53.712L22.0523 54.3338C19.778 54.8136 18.1433 56.8392 18.1433 59.1668H43.3388C43.3388 56.8392 41.7041 54.8136 39.4297 54.3338L36.4624 53.712C34.8633 53.3744 33.7261 51.9707 33.7261 50.336V50.0695C33.7261 46.8889 35.6806 44.0105 38.6302 42.8378L44.8135 40.3857C47.5321 39.3019 49.38 36.7965 49.6643 33.9181L54.6927 30.2045C58.7261 27.2372 61.1071 22.5286 61.1071 17.5179V5.71978C61.1071 4.476 60.112 3.48097 58.8682 3.48097H58.9038ZM4.85261 17.5357V7.95858H11.7645V28.3211L9.43683 26.6153C6.55837 24.5009 4.85261 21.1071 4.85261 17.5357ZM56.665 17.5357C56.665 21.1071 54.9415 24.5009 52.0808 26.6153L49.7531 28.3211V7.95858H56.665V17.5357Z"
          fill="url(#paint0_linear_9893_3065)"
        />
        <path
          d="M42.8768 17.9976C42.6991 17.4646 42.2016 17.0915 41.633 17.0915H34.2769L32.0026 10.0908C31.8249 9.5577 31.3274 9.18457 30.7588 9.18457C30.1902 9.18457 29.6927 9.53994 29.515 10.0908L27.2406 17.0915H19.8846C19.316 17.0915 18.8185 17.4468 18.6408 17.9976C18.4631 18.5485 18.6408 19.117 19.1205 19.4546L25.0729 23.7901L22.7986 30.7908C22.6209 31.3239 22.7986 31.9102 23.2783 32.2478C23.7581 32.5854 24.3444 32.5854 24.8064 32.2478L30.7588 27.9124L36.7112 32.2478C36.9421 32.4077 37.2087 32.4966 37.4752 32.4966C37.7417 32.4966 38.0082 32.4077 38.2392 32.2478C38.7012 31.9102 38.8789 31.3239 38.719 30.7908L36.4446 23.7901L42.397 19.4546C42.859 19.117 43.0367 18.5307 42.8768 17.9976Z"
          fill="#3300FF"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_9893_3065"
          x1="30.7588"
          y1="64.5684"
          x2="30.7588"
          y2="-9.06345"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3B6AE3" />
          <stop offset="0.5" stop-color="#19B0E1" />
        </linearGradient>
        <clipPath id="clip0_9893_3065">
          <rect
            width="60.7676"
            height="58.3333"
            fill="white"
            transform="translate(0.375 0.833496)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export default Champ
